module.exports = __webpack_public_path__ + "add-documents.svg?70d68057121a57752c94cbed6a483434";